module.exports = __webpack_public_path__ + "static/img/voice3_down.22fd6bda.png";